export default __webpack_public_path__ + "static/media/main_title.00682115.png";